import { VStack, Text } from '@chakra-ui/react';
import { EventDetailCard } from '../../';
import { isSameDay } from 'date-fns';
import type { IEvent } from '../../../../lib/types';

interface IEventList {
	events: IEvent[];
}
export const EventList: React.FunctionComponent<IEventList> = ({ events }) => {
	return events.length > 0 ? (
		<VStack>
			{events.map((event, index) => {
				return (
					<EventDetailCard
						key={index}
						event={event}
						isListItem={true}
						isSameDayEvent={isSameDay(event.start, event.end)}
					/>
				);
			})}
		</VStack>
	) : (
		<Text fontWeight='300' padding={2} mx={0} border='1px solid' borderColor='#e5e5e5' borderRadius='md'>
			No Event Found.
		</Text>
	);
};
